import { render, staticRenderFns } from "./OwnerData.vue?vue&type=template&id=5a752eb0&"
import script from "./OwnerData.vue?vue&type=script&lang=js&"
export * from "./OwnerData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports